module.exports = __webpack_public_path__ + "img/feature-11.7e5d9b71.png";